import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppComponent } from '../app.component';
import { Applicationcl } from '../Model/Applicationcl';
import { GRbookingervice } from '../service/GRbookingservice';
import { MasterConfigrationService } from '../service/MasterConfigrationService';
import { AutoLogoutService } from 'src/app/service/auto-logout.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: [ './dashboard.component.css' ]
})
export class DashboardComponent implements OnInit {
  public userId!: number;
  public GrDetailData!: any[];
  public IntranVeData!: any[];
  public PendingDelData!: any[];
  public RUrl!: string;
  public TotalBooking!: number;
  public totalweight!: number;
  public totalpackage!: number;
  public totalFullLoad!: number;
  public RoleId!: number;

  constructor (private oAppComponent: AppComponent, public oGRbookingservice: GRbookingervice, public AutoLogoutService: AutoLogoutService,
    private oApplicationcl: Applicationcl, private _service: MasterConfigrationService) {
    oAppComponent.ngOnInit();
    this.AutoLogoutService.CheckAuthentication();
    this.userId = parseInt(sessionStorage.getItem("userid")!);
    this.RoleId = parseInt(sessionStorage.getItem("RoleId")!);
    this.RUrl = environment.MvcWebUrl;
  }

  ngOnInit(): void {

  }

}
